import {
    primaryColor,
    primaryBoxShadow,
    coloredShadow,
    container,
    main,
    progress,
    description,
    title,
    defaultFont,
    dangerColor,
    cardTitle,
    grayColor
} from "@app/assets/jss/material-kit-pro-react.jsx";
import customInputStyle from "@app/assets/jss/material-kit-pro-react/components/customInputStyle.jsx";
import customCheckboxRadioSwitch from "@app/assets/jss/material-kit-pro-react/components/customCheckboxRadioSwitchStyle.jsx";
import modalStyle from "@app/assets/jss/material-kit-pro-react/modalStyle.jsx";
import imagesStyles from "@app/assets/jss/material-kit-pro-react/imagesStyles.jsx";

const profileWizardStyle = theme => ({
    progress,
    description,
    container,
    coloredShadow,
    ...imagesStyles,
    main: {
        ...main,
        marginTop: "0px",
        paddingTop: "59px"
    },
    pagination: {
        marginTop: "20px",
        marginBottom: "0px",
        justifyContent: "center"
    },
    ...modalStyle(theme),
    modal: {
        ...modalStyle(theme).modal,
        maxWidth: "400px !important",

    },
    modalTitle: {
        ...modalStyle(theme).modalTitle,
        fontWeight: "400"
    },
    modalBody: {
        ...modalStyle(theme).modalBody,
        paddingLeft: "30px",
        paddingRight: "30px"
    },
    modalItem: {
        ...defaultFont,
        fontSize: "13px",
        padding: "10px 20px",
        margin: "0 5px 5px",
        borderRadius: "2px",
        transition: "all 150ms linear",
        clear: "both",
        fontWeight: "400",
        height: "100%",
        whiteSpace: "nowrap",
        color: "#333 !important",
        "&:hover": {
            color: "#FFFFFF !important",
            backgroundColor: primaryColor[1],
            ...primaryBoxShadow
        }
    },
    modalFooterCenter: {
        ...modalStyle(theme).modalFooterCenter,
        marginBottom: "0px",
        justifyContent: "center"
    },
    justifyContentCenter: {
        WebkitBoxPack: "center !important",
        MsFlexPack: "center !important",
        justifyContent: "center !important"
    },
    formButtons: {
        marginRight: "0px"
    },
    imageGalleryButtons: {
        marginRight: "5px"
    },
    inputFontAwesomeIcons: {
        color: "#495057 !important",
        paddingLeft: "2px",
        fontSize: "24px"
    },
    inputIconsColor: {
        color: "#495057"
    },
    disabled: {
        ...customInputStyle.disabled
    },
    underline: {
        ...customInputStyle.underline
    },
    inputLabel: {
        ...customInputStyle.labelRoot,
        position: "absolute",
        left: "0"
    },
    cardTitle: {
        ...cardTitle,
        color: "#FFFFFF !important",
        marginBottom: "10px !important"
    },
    cardTitleDark: {
        ...cardTitle,
    },
    cardCategory: {
        marginTop: "10px"
    },
    cardProfile: {
        marginTop: "50px",
        marginBottom: "50px"
    },
    cardHeaderProfile: {
        width: "auto",
        textAlign: "center",
        marginLeft: "20px",
        marginRight: "20px",
        padding: "20px 0",
        marginBottom: "15px"
    },
    cardBodyProfile: {
        padding: "0px 30px 0px 30px"
    },
    cardProfileTab: {
        marginTop: "0px"
    },
    cardBodyProfileTab: {
        paddingTop: "0px",
        paddingBottom: "0px"
    },
    cardFooterProfileTab: {
        marginTop: "5px",
        marginBottom: "0px",
        paddingBottom: "0px",
        WebkitBoxPack: "justify !important",
        MsFlexPack: "justify !important",
        justifyContent: "center !important",
        "& button": {
            marginRight: "20px"
        },
        "& button:last-child": {
            marginRight: "0px"
        }
    },
    cardFooterProfileWithoutFormTab: {
        marginTop: "25px",
        marginBottom: "1.125rem",
        paddingBottom: "0px",
        WebkitBoxPack: "justify !important",
        MsFlexPack: "justify !important",
        justifyContent: "center !important",
        "& button": {
            marginRight: "20px"
        },
        "& button:last-child": {
            marginRight: "0px"
        }
    },
    cardTeamMember: {
        textAlign: "center",
        marginTop: "10px"
    },
    cardHeaderTeamMember: {
        width: "100%",
        paddingTop: "125%",
        position: "relative",
        "& img": {
            position: "absolute",
            top: "0",
            left: "0"
        }
    },
    cardHeaderTeamMemberButtons: {
        marginTop: "5px",
        WebkitBoxPack: "justify !important",
        MsFlexPack: "justify !important",
        justifyContent: "center !important",
        "& button": {
            marginRight: "10px"
        },
        "& button:last-child": {
            marginRight: "0px"
        }
    },
    cardBodyTeamMember: {
        paddingTop: "0px",
        paddingBottom: "0px"
    },
    cardAvatarThumbnail: {
        width: "100px",
        paddingBottom: "125px",
        marginLeft: "0px",
        marginTop: "5px"
    },
    cardImageThumbnail: {
        marginTop: "5px",
        background: "#e7e7e7"
    },
    cardImageThumbnailInner: {
        position: "absolute",
        top: "0",
        left: "0",
        height: "100%",
        width: "100%",
        "& img": {
            height: "100%",
            width: "auto",
            maxWidth: "100%",
            marginLeft: "auto",
            marginRight: "auto"
        }
    },
    cardLogoThumbnail: {
        width: "100px",
        paddingBottom: "100px",
        marginLeft: "0px",
        marginTop: "5px"
    },
    cardBodyLogoThumbnail: {
        padding: "5px"
    },
    cardButtonThumbnail: {
        minWidth: "30px",
        width: "30px",
        height: "30px"
    },
    thumbnailFormControl: {
        margin: "0 0 17px 0",
        paddingTop: "27px",
        position: "relative"
    },
    thumbnailFormGroup: {
        display: "flex",
        justifyContent: "flex-end"
    },
    thumbnailSpinner: {
        color: grayColor[1],
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        marginTop: "30px"
    },
    imageGallery: {
        marginTop: "30px",
        marginBottom: "0px",
        "& .image-gallery-slides": {
            position: "relative",
            height: "0",
            paddingTop: "67%"
        },
        "& .image-gallery-slide-wrapper": {
            marginBottom: "10px"
        },
        "& .image-gallery-slide": {
            height: "100%",
            width: "100%",
            position: "absolute",
            top: "0",
            left: "0",
            paddingLeft: "5px",
            paddingRight: "5px"
        },
        "& .image-gallery-slide img": {
            borderRadius: "3px",
            height: "100%",
            width: "auto",
            maxWidth: "100%"
        },
        "& .image-gallery-slide.center": {
            position: "absolute"
        },
        "& .image-gallery-image": {
            height: "100%"
        },
        "& .image-gallery-swipe": {
            overflow: "hidden",
            textAlign: "center"
        },
        "& .image-gallery-image": {
            height: "100%",
            textAlign: "center"
        },
        "& .image-gallery-thumbnails > .image-gallery-thumbnails-container a": {
            "&.active > div": {
                opacity: "1",
                borderColor: "#00acc1",
                padding: "3px"
            },
            "& > div": {
                width: "120px",
                height: "80px",
                display: "inline-block",
                border: "3px solid transparent",
                background: "transparent",
                borderRadius: "3px",
                opacity: ".8"
            },
            "& > div img": {
                borderRadius: "3px",
                width: "auto",
                height: "100%",
                textAlign: "center",
                margin: "0px"
            }
        }
    },
    title: {
        ...title,
        marginTop: "0px",
        marginBottom: "0px",
        textAlign: "center"
    },
    description: {
        color: "#999"
    },
    thumbnailTitle: {
        ...title,
        marginTop: "0px",
        marginBottom: "0px",
        marginLeft: "5px",
        minHeight: "0px"
    },
    helperTextError: {
        ...defaultFont,
        color: dangerColor[1] + " !important",
        fontSize: "12px",
        fontWeight: "400",
        lineHeight: "1.42857",
        top: "10px",
        marginTop: "10px"
    },
    checkboxFormControl: {
        margin: "0 0 17px 0",
        paddingTop: "38px",
        position: "relative"
    },
    ...customCheckboxRadioSwitch,
    checkboxAndRadioHorizontal: {
        ...customCheckboxRadioSwitch.checkboxAndRadioHorizontal,
        marginBottom: "10px"
    },
    checkboxLabel: {
        ...customCheckboxRadioSwitch.label,
        color: "#495057 !important",
    },
    textAlignCenter: {
        textAlign: "center"
    },
    buttonAlignCenter: {
        margin: "auto"
    },
    suggestionsContainer: {
        position: 'relative'
    },
    suggestionsContainerOpen: {
        position: 'absolute',
        zIndex: 1,
        marginTop: theme.spacing.unit,
        left: 0,
        right: 0,
        margin: '-10px 0 !important'
    },
    suggestion: {
        margin: "0",
        display: 'block',
        "& > div:hover": {
            backgroundColor: primaryColor[1] + " !important",
            color: "#FFFFFF !important",
            borderRadius: "2px",
            ...primaryBoxShadow
        }
    },
    suggestionsList: {
        margin: '0px',
        padding: '5px',
        listStyleType: 'none'
    },
    linkAuthProviderButton: {
        justifyContent: "left",
        maxWidth: "max-content",
        padding: "5px 5px"
    }
});

export default profileWizardStyle;
